module.exports = __webpack_public_path__ + "f72a8f00b28aad609e0eac55194053d1.jpg";